import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../fragments/button';
import {gzipJSON, getStorage} from '../../../utils/storage';
import {download} from '../../../utils/file-utils';
import RawDataCollection from '../../../models/raw-data-collection';
import ExportedTableRow from '../../../models/exported-table-row';

import {
  create_workbook,
  create_worksheet,
  add_worksheet,
  write_workbook,
} from '../../../components/workbook';

export default class Finish extends React.Component {

  static contextTypes = {
    router: PropTypes.shape({
      replace: PropTypes.func.isRequired
    }).isRequired
  };

  constructor() {
    super(...arguments);
    this.state = {
      loading: true,
      rawDataCollection: new RawDataCollection(),
      loadDataError: false
    };
  }

  async componentDidMount() {
    const {location: {query}} = this.props;
    if (!query || !('load' in query)) {
      this.setState({loadDataError: true});
      return;
    }
    const {rawDataCollection} = await getStorage(query.load);
    this.setState({rawDataCollection, loading: false});
  }

  async onDownloadButtonClick() {
    const {rawDataCollection} = this.state;
    const {
      references,
      patientList: patients,
      isolateList: isolates
    } = rawDataCollection;

    const data = {
      references: references.map(r => r.exportData()),
      patients: patients.map(p => p.exportData()),
      isolates: isolates.map(i => i.exportData())
    };

    const blob = gzipJSON(data);
    const [{humanRefName}] = references.concat([{humanRefName: 'data-update-only'}]);
    download(blob, 'application/gzip', `${humanRefName}-dump.dat`);

  }

  async onDownloadExportedTableClick() {
    const {exportedTable} = this.state.rawDataCollection;
    const wb = create_workbook();
    const header = Object.keys(ExportedTableRow.propTypes);
    let rows = [];
    for (const record of exportedTable) {
      let row = [];
      for (const key of header) {
        row.push(record[key]);
      }
      rows.push(row);
    }
    const ws = create_worksheet(header, rows);
    add_worksheet(wb, ws, 'Sheet1');
    write_workbook(wb, 'Data check file.xlsx');
  }

  render() {
    const {loading, rawDataCollection} = this.state;
    const {patientList, isolateList} = rawDataCollection;
    const patientsLen = patientList.length;
    const isolatesLen = isolateList.length;
    const isPtPlural = patientsLen > 1;
    const isIsoPlural = isolatesLen > 1;
    const {seqType} = rawDataCollection;
    const isClinical = !seqType || seqType === 'ClinicalList';

    return <div>
      {loading ? null :
      <p>
         There are{' '}
        {isClinical ?
        `${patientsLen} ${isPtPlural ? 'patients' : 'patient'} and${' '}` :
        null}
        {isolatesLen} {isIsoPlural ? 'isolates' : 'isolate'}.
         You can download the generated file package and import them into the
         HIVDB2 database.
       </p>}
      <p>
        Download:
        <Button
         name="download"
         btnStyle="primary"
         disabled={loading}
         onClick={this.onDownloadButtonClick.bind(this)}>
          Data File
        </Button>
        <Button
         name="exportedTable"
         btnStyle="info"
         disabled={loading}
         onClick={
          this.onDownloadExportedTableClick.bind(this)}>
          Data check file
        </Button>
      </p>
    </div>;
  }

}



// WEBPACK FOOTER //
// ./src/views/wizard/finish/index.js